import React from "react";
import PropTypes from "prop-types";
import cx from "classnames/bind";
// eslint-disable-next-line import/no-cycle
import { Link } from "../../sharedComponents/Link";
import { Heading, HeadingSize, HeadingType } from "../Headings/Heading";
import { List, ListStyle } from "../List";
import { Button } from "../Button";
import * as styles from "./LinksList.module.scss";

const LinksList = ({ style, className, title, titleSize, titleAs, linkEntries, listStyle }) => (
	<>
		{title && (
			<Heading as={titleAs} size={titleSize}>
				{title}
			</Heading>
		)}
		<List
			listStyle={listStyle}
			list={linkEntries}
			className={cx(styles.linksList, {
				[styles[listStyle]]: listStyle,
				[className]: className,
			})}
			style={style}>
			{linkEntries?.map(l => (
				<List.Item key={l.id}>
					{listStyle === "buttons" ? (
						<Button
							outline="true"
							to={l.url}
							target={l.target}
							showExternalIcon={true}
							className={styles.linksButton}>
							{l.linkText}
						</Button>
					) : (
						<Link to={l.url} target={l.target}>
							{l.linkText}
						</Link>
					)}
				</List.Item>
			))}
		</List>
	</>
);

LinksList.propTypes = {
	className: PropTypes.string,
	title: PropTypes.string,
	titleAs: PropTypes.oneOf([...HeadingType]),
	titleSize: PropTypes.oneOf([...HeadingSize]),
	linkEntries: PropTypes.arrayOf(
		PropTypes.shape({
			url: PropTypes.string.isRequired,
			target: PropTypes.string,
			linkText: PropTypes.string,
			id: PropTypes.string,
		})
	).isRequired,
	listStyle: PropTypes.oneOf([...ListStyle]),
	style: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
};
LinksList.defaultProps = {
	className: "",
	title: undefined,
	titleAs: "h2",
	titleSize: "h2",
	listStyle: "arrowed",
	style: {},
};

export default LinksList;
export { LinksList };
